import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { StrikeWeightRatioDesignMode, type StrikeWeightRatioDesignTarget } from '@/lib/piano/touch-design/design/strike-weight-ratio-design';
import { useDesignActions, useStrikeWeightRatioDesign } from '@/hooks/store/use-design-store';
import { SmoothStrategy } from '@/lib/geometry/curve-smoother/smooth-strategy.enum';
export const useStrikeWeightRatioTargetSelector = () => {
  const $ = _c(13);
  const {
    strikeWeightRatioDesignMode,
    strikeWeightRatioDesignTarget,
    strikeWeightRatioDesignLatestFixedTarget,
    strikeWeightRatioDesignLatestSmoothTarget
  } = useStrikeWeightRatioDesign();
  const {
    updateStrikeWeightRatioDesign
  } = useDesignActions();
  let t0;
  if ($[0] !== strikeWeightRatioDesignMode || $[1] !== updateStrikeWeightRatioDesign) {
    t0 = target => {
      updateStrikeWeightRatioDesign(strikeWeightRatioDesignMode, target);
    };
    $[0] = strikeWeightRatioDesignMode;
    $[1] = updateStrikeWeightRatioDesign;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onTargetChange = t0;
  let t1;
  if ($[3] !== strikeWeightRatioDesignLatestFixedTarget || $[4] !== strikeWeightRatioDesignLatestSmoothTarget || $[5] !== updateStrikeWeightRatioDesign) {
    t1 = mode => {
      if (mode === StrikeWeightRatioDesignMode.Smoothed) {
        updateStrikeWeightRatioDesign(mode, strikeWeightRatioDesignLatestSmoothTarget ?? SmoothStrategy.Median);
      } else {
        if (mode === StrikeWeightRatioDesignMode.FixedValue) {
          updateStrikeWeightRatioDesign(mode, strikeWeightRatioDesignLatestFixedTarget);
        } else {
          updateStrikeWeightRatioDesign(mode, null);
        }
      }
    };
    $[3] = strikeWeightRatioDesignLatestFixedTarget;
    $[4] = strikeWeightRatioDesignLatestSmoothTarget;
    $[5] = updateStrikeWeightRatioDesign;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const onModeChange = t1;
  let t2;
  if ($[7] !== onModeChange || $[8] !== onTargetChange || $[9] !== strikeWeightRatioDesignMode || $[10] !== strikeWeightRatioDesignTarget || $[11] !== updateStrikeWeightRatioDesign) {
    t2 = {
      onModeChange,
      onTargetChange,
      strikeWeightRatioDesignMode,
      strikeWeightRatioDesignTarget,
      updateStrikeWeightRatioDesign
    };
    $[7] = onModeChange;
    $[8] = onTargetChange;
    $[9] = strikeWeightRatioDesignMode;
    $[10] = strikeWeightRatioDesignTarget;
    $[11] = updateStrikeWeightRatioDesign;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};